var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"48","viewBox":"0 96 960 960","width":"48"}},[_c('path',{attrs:{"d":"M450 856V606H200v-60h250V296h60v250h250v60H510v250h-60Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }